import type { GeofenceColor as GeofenceColorOptions } from '@cobliteam/common-types/src/geofenceV3';
import { colors } from '@cobliteam/ui/theme';

export type GeofenceColorType = {
  value: GeofenceColorOptions;
  color: string;
  label: GeofenceColorOptions;
  className: string;
  bgColor: string;
  textColor: string;
};

const GeofenceColors: GeofenceColorType[] = [
  // DEFAULT
  {
    value: 'DEFAULT',
    color: colors.gray[11],
    label: 'DEFAULT',
    className: 'border-gray-11 bg-gray-11 data-[state=checked]:border-gray-12 data-[state=checked]:bg-gray-11',
    textColor: 'text-gray-11',
    bgColor: 'bg-gray-11',
  },
  // Primary Colors - Most accessible and distinct
  {
    value: 'RED',
    color: colors.accessory.tomato[11],
    label: 'RED',
    className: 'border-accessory-tomato-11 bg-accessory-tomato-11 data-[state=checked]:border-accessory-tomato-12 data-[state=checked]:bg-accessory-tomato-11',
    bgColor: 'bg-accessory-tomato-11',
    textColor: 'text-accessory-tomato-11',
  },
  {
    value: 'GREEN',
    color: colors.accessory.green[11],
    label: 'GREEN',
    className: 'border-accessory-green-11 bg-accessory-green-11 data-[state=checked]:border-accessory-green-12 data-[state=checked]:bg-accessory-green-11',
    bgColor: 'bg-accessory-green-11',
    textColor: 'text-accessory-green-11',
  },
  {
    value: 'BLUE',
    color: colors.primary[11],
    label: 'BLUE',
    className: 'border-primary-11 bg-primary-11 data-[state=checked]:border-primary-12 data-[state=checked]:bg-primary-11',
    bgColor: 'bg-primary-11',
    textColor: 'text-primary-11',
  },
  {
    value: 'YELLOW',
    color: colors.accessory.gold[11],
    label: 'YELLOW',
    className: 'border-accessory-gold-11 bg-accessory-gold-11 data-[state=checked]:border-accessory-gold-12 data-[state=checked]:bg-accessory-gold-11',
    bgColor: 'bg-accessory-gold-11',
    textColor: 'text-accessory-gold-11',
  },
  {
    value: 'ORANGE',
    color: colors.accessory.orange[11],
    label: 'ORANGE',
    className: 'border-accessory-orange-11 bg-accessory-orange-11 data-[state=checked]:border-accessory-orange-12 data-[state=checked]:bg-accessory-orange-11',
    bgColor: 'bg-accessory-orange-11',
    textColor: 'text-accessory-orange-11',
  },
  {
    value: 'PURPLE',
    color: colors.accessory.purple[11],
    label: 'PURPLE',
    className: 'border-accessory-purple-11 bg-accessory-purple-11 data-[state=checked]:border-accessory-purple-12 data-[state=checked]:bg-accessory-purple-11',
    bgColor: 'bg-accessory-purple-11',
    textColor: 'text-accessory-purple-11',
  },

  // Secondary Colors - Still accessible but less primary
  {
    value: 'TOMATO',
    color: colors.accessory.tomato[9],
    label: 'TOMATO',
    bgColor: 'bg-accessory-tomato-9',
    className: 'border-accessory-tomato-9 bg-accessory-tomato-9 data-[state=checked]:border-accessory-tomato-10 data-[state=checked]:bg-accessory-tomato-9',
    textColor: 'text-accessory-tomato-9',
  },
  {
    value: 'LIME',
    color: colors.accessory.lime[10],
    label: 'LIME',
    bgColor: 'bg-accessory-lime-10',
    className: 'border-accessory-lime-10 bg-accessory-lime-10 data-[state=checked]:border-accessory-lime-11 data-[state=checked]:bg-accessory-lime-10',
    textColor: 'text-accessory-lime-10',
  },
  {
    value: 'SKY',
    color: colors.accessory.sky[10],
    label: 'SKY',
    bgColor: 'bg-accessory-sky-10',
    className: 'border-accessory-sky-10 bg-accessory-sky-10 data-[state=checked]:border-accessory-sky-11 data-[state=checked]:bg-accessory-sky-10',
    textColor: 'text-accessory-sky-10',
  },
  {
    value: 'GOLD',
    color: colors.accessory.gold[9],
    label: 'GOLD',
    bgColor: 'bg-accessory-gold-9',
    className: 'border-accessory-gold-9 bg-accessory-gold-9 data-[state=checked]:border-accessory-gold-10 data-[state=checked]:bg-accessory-gold-9',
    textColor: 'text-accessory-gold-9',
  },
  {
    value: 'PINK',
    color: colors.accessory.pink[10],
    label: 'PINK',
    bgColor: 'bg-accessory-pink-10',
    className: 'border-accessory-pink-10 bg-accessory-pink-10 data-[state=checked]:border-accessory-pink-11 data-[state=checked]:bg-accessory-pink-10',
    textColor: 'text-accessory-pink-10',
  },
  {
    value: 'INDIGO',
    color: colors.accessory.indigo[10],
    label: 'INDIGO',
    className: 'border-accessory-indigo-10 bg-accessory-indigo-10 data-[state=checked]:border-accessory-indigo-11 data-[state=checked]:bg-accessory-indigo-10',
    bgColor: 'bg-accessory-indigo-10',
    textColor: 'text-accessory-indigo-10',
  },

  // Tertiary Colors
  {
    value: 'BROWN',
    color: colors.accessory.brown[10],
    label: 'BROWN',
    bgColor: 'bg-accessory-brown-10',
    className: 'border-accessory-brown-10 bg-accessory-brown-10 data-[state=checked]:border-accessory-brown-11 data-[state=checked]:bg-accessory-brown-10',
    textColor: 'text-accessory-brown-10',
  },
  {
    value: 'TEAL',
    color: colors.accessory.teal[10],
    label: 'TEAL',
    bgColor: 'bg-accessory-teal-10',
    className: 'border-accessory-teal-10 bg-accessory-teal-10 data-[state=checked]:border-accessory-teal-11 data-[state=checked]:bg-accessory-teal-10',
    textColor: 'text-accessory-teal-10',
  },
];

export default GeofenceColors;
